"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ListItemAvatarPropTypes", {
  enumerable: true,
  get: function get() {
    return _proptypes["default"];
  }
});
exports["default"] = void 0;
var _ListItemAvatar = _interopRequireDefault(require("./ListItemAvatar"));
var _proptypes = _interopRequireDefault(require("./proptypes"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var _default = exports["default"] = _ListItemAvatar["default"];